import { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { $userStore } from '@lib/store/userManagement';
import { ValidateUtils } from '@shared/utils';
import { BaseInput, Button, ErrorMessage, Modal, Text } from '@shared/widgets';

interface IForm {
  password: string;
  confirmPassword: string;
}
const DEFAULT_VALUES: IForm = { password: '', confirmPassword: '' };

interface IChangePasswordModal {
  show: boolean;
  onClose: () => void;
  userId: string;
}

export const ChangePasswordModal = (props: IChangePasswordModal) => {
  const { control, formState, handleSubmit, watch, setError, reset } = useForm<IForm>({ defaultValues: DEFAULT_VALUES });
  const password = watch('password');
  const confirmPassword = watch('confirmPassword');

  useEffect(() => {
    if (password === confirmPassword) setError('confirmPassword', { message: '' });
  }, [password]);

  const closeHandler = () => {
    reset(DEFAULT_VALUES);
    props.onClose();
  };
  const submitHandler = async (data: IForm) => {
    await $userStore.events.changePassword({
      userId: props.userId,
      password: data.password,
      confirmPassword: data.confirmPassword,
    });
    closeHandler();
  };

  return (
    <Modal isOpen={props.show} onClose={closeHandler} title='Change password' width='332px'>
      <form className='flex flex-col gap-5' onSubmit={handleSubmit(submitHandler)}>
        <Controller
          name='password'
          control={control}
          rules={{
            required: ValidateUtils.requiredErrorMessage,
            minLength: { value: 8, message: 'Password must be at least 8 characters long' },
            pattern: { value: ValidateUtils.passwordRegex, message: ValidateUtils.passwordErrorMessage },
          }}
          render={({ field, fieldState: { error } }) => (
            <div>
              <BaseInput {...field} type='password' placeholder='New password' />
              <ErrorMessage text={error?.message} />
            </div>
          )}
        />
        <Text>8 characters minimum, at least one number, one capital letter and one special character</Text>
        <Controller
          name='confirmPassword'
          control={control}
          rules={{
            required: ValidateUtils.requiredErrorMessage,
            validate: (value) => value === password || 'Passwords do not match',
          }}
          render={({ field, fieldState: { error } }) => (
            <div>
              <BaseInput {...field} type='password' placeholder='Repeat new password' />
              <ErrorMessage text={error?.message} />
            </div>
          )}
        />
        <Button className='mt-7' color='primary' fullWidth type='submit' disabled={formState.isSubmitting}>
          Change password
        </Button>
      </form>
    </Modal>
  );
};
